import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react';

if(['production', 'staging', 'production2', 'staging2'].includes(process.env.REACT_APP_ENV)) {
  Bugsnag.start({
    apiKey: '4a1500ed2e645569d4648d87f85f3d79',
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: process.env.REACT_APP_ENV || 'development',
  });
}
